/***************************************************************************************
* FileName      : MyInquiry.js
* Description   : 고객 > 마이페이지 > 상품 Q&A 내역 
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2023.12.00
* Modifide Date : 
* Reference     : 
***************************************************************************************/
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import MypageTabComponent from './MypageTab.js';
import Sidemenu from './Sidemenu.js';
import StatusBar from './StatusBar.js';

import { useMyInquiryProductListQuery } from '../../api/services/mypageApi.js';

import Pagination from '../customer/common/Pagination.js';
import MyInquiryRow from './MyInquiry/MyInquiryRow.js';

function MyInquiryLayout()
{

    return(
        <>
        <Container>
            <StatusBar/>
            <Row className='m-0'>
                <div className='mypage_wrap'>
                    <Col md={3} lg={3}><Sidemenu nowPage={'qnaList'}/></Col>
                    <Col xs={12} sm={12} md={9} lg={9}>
                        <MyInquiry/>
                    </Col>
                </div>
            </Row>

        </Container>
        
        </>
      )
}

function MyInquiry()
{
    const { data:myInquiryProduct, error, isFetching, page, setPage } = useMyInquiryProductListQuery();


    const [searchConfirm, setSearchConfirm] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    if (!myInquiryProduct) {
        return <div>Loading...</div>;
    }

    // console.log(myInquiryProduct);


    const handlePrevPage = () => {
        setPage(prevPage => prevPage - 1);
    };
      
    const handleNextPage = () => {
        setPage(prevPage => prevPage + 1);
    };
          
    return(
        <>
        <div className='mypage_area_sub p-xs-1 p-md-4 mt-2'>          
            <Row className='title-aream-0 p-0'>
                <Col className='m-0 p-0 mb-4'>
                    <h3 class="m-0 p-0 fs-5 fw-bold">상품 Q&A 문의내역</h3>
                </Col>
            </Row>

            {/*
            <div className='mp-search-area mb-4'>
                검색
            </div>
            */}
            
            <table className='mypage-table'>
                <colgroup>
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '45%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '15%' }} />
                    <col style={{ width: '5%' }} />

                </colgroup>
                <thead >
                    <tr>
                        <th>상품명</th>
                        <th>문의내용</th>
                        <th>등록일</th>
                        <th>답변상태</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody className='history'>
                    {searchConfirm && searchResults?.count === 0 ? (
                        <tr>
                            <td colSpan="17">검색 결과가 없습니다.</td>
                        </tr>
                    ) : searchResults?.count > 0 ? (
                        searchResults?.data.map((inquiry) => (
                            <MyInquiryRow
                                key={inquiry?.id}
                                inquiry={inquiry}
                        />
                        ))
                    ) : myInquiryProduct && myInquiryProduct?.data && myInquiryProduct?.data.length > 0 ? (
                        myInquiryProduct?.data.map((inquiry) => (
                            <MyInquiryRow
                                key={inquiry?.id}
                                inquiry={inquiry}
                            />
                        ))
                    ) : null}

                </tbody>
                
            </table>

            {/* 페이지내비게이션 */}
            <section className='mt-5'>
              <Pagination
                  count={myInquiryProduct?.totalCnt || 0}
                  page={page}
                  setPage={setPage}
                  handlePrevPage={handlePrevPage}
                  handleNextPage={handleNextPage}
              />
          </section>
        </div>
        </>
    )
}


export default MyInquiryLayout